import { Booking } from '@/src/api/bookingsApi';
import { ParticipationRequestStatus } from '@/src/api/participationRequestsApi';
import { useRouter } from 'expo-router';
import { ReactNode } from 'react';
import PSLinkButton from './ui/PSLinkButton';
import { YStack } from 'tamagui';
import PSBox from './ui/PSBox';

export function RequestNotice({
  status,
  booking,
  pendingCopy,
  approvedCopy,
  rejectedCopy,
  blockedCopy,
}: {
  status: ParticipationRequestStatus;
  booking?: Booking;
  pendingCopy?: ReactNode;
  approvedCopy?: ReactNode;
  rejectedCopy?: ReactNode;
  blockedCopy?: ReactNode;
}) {
  const router = useRouter();

  function renderCopy(): ReactNode {
    switch (status) {
      // No seat yet — an organizer still has to approve it on Backstage — so
      // there's nowhere useful to send the reader.
      case 'pending':
        return pendingCopy;

      // The booking on an approved request is a real, confirmed one, so the
      // ticket is on `/bookings/[id]` — this screen stays the receipt of the
      // application and hands the reader over.
      case 'approved':
        return (
          <>
            {approvedCopy}
            <PSLinkButton
              variant="brand"
              title="View your booking"
              onPress={() =>
                booking
                  ? router.push(`/bookings/${booking.id}`)
                  : router.push('/profile')
              }
            />
          </>
        );

      case 'rejected':
        return rejectedCopy;

      // Same verdict as rejected, minus the way back: a blocked applicant is
      // barred from this tier for good, so no reapply link.
      case 'blocked':
        return blockedCopy;
    }
  }

  return (
    <PSBox backgroundColor={'$color.backgroundSecondary'}>{renderCopy()}</PSBox>
  );
}
